import React, {useEffect, useState} from 'react'
import { Modal } from "../../../../../common/modal";

import StatePicker from "../../../../../common/state-picker";
import SecondaryChainSelect from "./secondary-chain-select";
import LocationSelect from "./location-select";

function SourceSelect({ updateField, chain_id, type, state_name, location_id, secondary_chain_id }) {
  switch(type) {
    case 'by_state':
      return (
        <StatePicker
          state={state_name}
          update={(newState) => {
            updateField('state_name', newState)
          }}
        />
      )
    case 'by_location':
      return (
        <LocationSelect
          updateField={updateField}
          chain_id={chain_id}
        />
      )
    case 'by_secondary_chain':
      return (
        <SecondaryChainSelect
          secondary_chain_id={secondary_chain_id}
          chain_id={chain_id}
          className="focus:ring-teal-500 focus:border-teal-500 col-start-1 row-start-1 w-64 appearance-none  rounded-md bg-white py-1.5 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 sm:text-sm/6"
          updateField={updateField}
        />
      )
    default:
      return null;
  }
}

export default function AddStandardRuleModal({ ruleset, showModal, handleCreateRule, handleCancel }) {
  const [newRule, setNewRule] = useState({
    locations_by: 'by_state',
    location_id: null,
    secondary_chain_id: null,
    state_name: '',
    strategy: ruleset.policy_type == 'def_rebate' ? 'retail_minus' : 'better_of',
    cost_plus: 0.00,
    retail_minus: 0.00
  });

  function updateField(field, value) {
    setNewRule({
      ...newRule,
      [field]: value
    })
  }

  function handleSave() {
    if(newRule.locations_by === 'by_state' && newRule.state_name === '') {
      return
    }

    if (newRule.locations_by === 'by_location' && !newRule.location_id) {
      return
    }

    if(newRule.locations_by === 'by_secondary_chain' && !newRule.secondary_chain_id) {
      return;
    }

    handleCreateRule(newRule)
  }

  return (
    <Modal
      title="Add Rule"
      open={showModal}
      primaryButtonText="Add"
      secondaryButtonText="Cancel"
      onPrimary={handleSave}
      onSecondary={handleCancel}
      setOpen={handleCancel}
    >
      <div>
        <label htmlFor="type" className="block text-sm font-normal text-gray-700">
          Rule Type
        </label>
        <div className="mt-1 grid grid-cols-1">
          <select
            id="type"
            name="type"
            value={newRule.locations_by}
            className="
              focus:ring-teal-500 focus:border-teal-500
              col-start-1 row-start-1 w-64 appearance-none  rounded-md bg-white py-1.5 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 sm:text-sm/6
            "
            onChange={(e) => {
              updateField('locations_by', e.target.value);
            }}
          >
            <option value="by_state">State</option>
            <option value="by_location">Location</option>
            <option value="by_secondary_chain">Secondary Chain</option>
          </select>
        </div>
      </div>
      <div className="mt-3">
        <label className="block text-sm font-normal text-gray-700">
          Source
        </label>
        <div className="mt-1 grid grid-cols-1">
          <SourceSelect
            type={newRule.locations_by}
            secondary_chain_id={newRule.secondary_chain_id}
            location_id={newRule.location_id}
            state_name={newRule.state_name}
            updateField={updateField}
            chain_id={ruleset.chain_id}
          />
        </div>
      </div>
    </Modal>
  )
}
